<template>
  <div class="ut-fc ut-text-secondary cmp-distribution-statement_list-statement-sales-import-info">

    <template v-if="!loadingFlag">
      <table  v-if="channel!='costs' && channel!='income'" class="">
        <tbody class="">
          <tr 
            class=""
            v-for="item of totalSummary"
            :key="item.key"
              
          >
              <td class="">{{$dft.capHead(item['types'])}}</td>
              <td style="text-align:right" class="">{{item['units']}}</td>
              <td style="text-align:right" class="">
                {{item['amounts']}}<template v-if="item.amounts && item.amounts!=''"> {{`${currencyISO}`}} </template>
              </td>
          
          </tr>
        </tbody>
      </table>
    </template>
    <template v-else>
      <div style="margin: 20px;padding: 20px;">
        <img src="static/icons/loading.gif" alt />
      </div>  
    </template>  
  </div>
</template>

<script>


import DBox from "@dtplugins/dbox/dbox";



export default {
  props: {

    selectedStatementDetails:{
      type:Object,
      default: () => {}
    },
    totalSummary:{
      type:Array
    }

  },
  components: {
    DBox
   
  },

  data: function() {
    return {
  
    };
  },
  computed:{
    loadingFlag:function(){
      return this.selectedStatementDetails?.import_result_summary_loading||false
    },
    channel:function(){
        return this.selectedStatementDetails?.stmt?.digital_physical||''
    },
    currencyISO:function(){
      const currencyArray = this.selectedStatementDetails?.currencies ||[]
      const currencyID = this.selectedStatementDetails?.statement?.currency_id ||''
      return currencyArray.length>0 ? currencyArray.find(x=>x.currency_id==currencyID).currency_iso:this.$store.getters.account.client.default_currency
    }    
  
  },
  methods:{}
}
</script>
<style lang="scss">
.cmp-distribution-statement_list-statement-sales-import-info{
  

    // .ut-flex{
        
    //     // padding-left:10px;
    //     // padding-top: 5px;
    //     // flex-wrap: nowrap;
    //   div:nth-child(1) {
    //      // flex:1.5;
    //       width:100px;max-width:100px
    //   }

    //   div:nth-child(2) {
    //       //flex:1;
    //      text-align: right;
    //       width:100px;max-width:100px;
    //       margin-left: 20px;
    //   }

    //   div:nth-child(3) {
    //      // flex:1;
    //       text-align: right;
    //       width:100px;max-width:100px;
    //        margin-left: 20px;
    //   }
    // }
 

}
</style>